import Page2Header from "./page2-header";
export default Page2Header;
